// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".toggle-search[data-v-220f26ba]{align-items:center;display:flex;justify-content:center;transition:opacity .2s ease-out}@media(hover:hover){.toggle-search[data-v-220f26ba]{cursor:pointer}.toggle-search[data-v-220f26ba]:hover{opacity:.6}}.toggle-search div[data-v-220f26ba]{align-items:center;display:flex;height:1.8rem;justify-content:center;width:1.8rem}.toggle-search div svg[data-v-220f26ba]{width:100%;fill:#383838}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
